import CardDescription from './CardDescription.design';

export default CardDescription;